import React, { Component, ErrorInfo, ReactNode } from 'react'
import { newRelicLog, newRelicNoticeError } from '@/utils/newrelic'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class BlankScreenErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (typeof window !== 'undefined') {
      const errorMessage = error?.message || 'Unknown error'
      const errorName = error?.name || 'Error'
      const errorStack = error?.stack || 'No stack trace available'
      const componentStack = errorInfo?.componentStack || 'No component stack available'
      const currentUrl = window.location.href

      newRelicLog(
        {
          name: 'webclip_crash',
          errorMessage,
          errorName,
          errorStack,
          componentStack,
          currentUrl,
          timestamp: Date.now(),
        },
        'pageAction'
      )

      newRelicNoticeError(error, {
        errorBoundary: true,
        errorMessage,
        errorName,
        errorStack,
        componentStack,
        url: currentUrl,
      })

      const params = new URLSearchParams(window.location.search)
      const venueUuid = params.get('venue_uuid') || params.get('v')
      const ordering = params.get('ordering')
      const s2p = params.get('s2p')
      const homeUrl = venueUuid
        ? `/?venue_uuid=${venueUuid}${ordering === 'false' ? '&ordering=false' : ''}${s2p === 'true' ? '&s2p=true' : ''}`
        : '/'
      window.location.replace(homeUrl)
    }
  }

  render() {
    if (this.state.hasError) {
      return <div className="bg-black min-h-screen w-full" />
    }

    return this.props.children
  }
}
